export default "__VITE_ASSET__CteYc5so__"